import "./App.css";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {QueryParamProvider} from "use-query-params";
import {TermPage} from "./page/terms";
import {CookiesProvider} from "react-cookie";
import {DisplayDesign} from "./page/displayDesign";
import {createContext, Dispatch, useReducer} from "react";
import {ActionProps, initialState, reducer, StateProps} from "./hooks/CommonReducer";
import {LoginPage} from "./page/login";

export const AppContext = createContext(
  {} as { state: StateProps; dispatch: Dispatch<ActionProps> }
);

function App() {

  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <div className="App">
      <AppContext.Provider value={{ state, dispatch }}>

      <CookiesProvider>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={Route}>
            <Switch>
              <Route path="/pages/terms">
                <TermPage/>
              </Route>
              <Route path="/pages/login">
                <LoginPage/>
              </Route>
              <Route path="/pages/user/display_design">
                <DisplayDesign/>
              </Route>
            </Switch>
          </QueryParamProvider>
        </BrowserRouter>
      </CookiesProvider>
      </AppContext.Provider>
    </div>
  );
}

export default App;
